import * as z from 'zod/v4';

import { CHAIN_KEYS } from '@infinex/chain-config';

const gasActivity = z.object({
  id: z.uuid(),
  type: z.literal('GAS'),
  action: z.enum(['JIT_TOP_UP', 'PREPAID_TOP_UP', 'SPENT']),
  status: z.enum(['Success']),
  timestamp: z.date(),
  formattedGasAmount: z.string(),
  formattedAssetAmount: z.string(),
  chain: z.enum(CHAIN_KEYS),
  assetAddress: z.string(),

  txHash: z.string(),
  fromAddress: z.string(),
  toAddress: z.string(),
});

export type GasActivity = z.input<typeof gasActivity>;

export const getGasActivities = z.object({
  activities: z.array(gasActivity),
});

export type GetGasActivities = z.input<typeof getGasActivities>;
